/**
 * Utility to debug environment variables
 * Call this function to log information about environment variables
 */
export const debugEnvironmentVariables = () => {
  const env = process.env;
  
  console.log('Environment Debug Information:');
  console.log('NODE_ENV:', env.NODE_ENV);
  
  // Check for Stripe variables
  const stripeKey = env.REACT_APP_STRIPE_PUBLISHABLE_KEY || env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY;
  console.log('Stripe Key Status:', stripeKey ? 'Found (masked for security)' : 'Not Found');
  
  if (stripeKey) {
    // Only log first few characters for security
    console.log('Stripe Key Prefix:', stripeKey.substring(0, 8) + '...');
  }
  
  // Log API URL
  console.log('API URL:', env.REACT_APP_API_URL || 'Not defined');
  
  // Check if we're running in production
  console.log('Is Production:', env.NODE_ENV === 'production');
  
  // Count total environment variables
  console.log('Total Environment Variables:', Object.keys(env).length);
}; 